<template>
  <div>
    <b-badge v-if="isEncourager" pill class="bg-success-dark text-white mb-1">
      <font-awesome-icon icon="circle-check" />
      Incentivador · SALIC
    </b-badge>
    <h4
      v-if="!!concedente?.nome"
      class="mb-1 line-clamp-1-lines"
      v-text="concedente.nome"
    />
    <p
      v-if="displayAddress"
      class="text-sm mb-0 line-clamp-1-lines"
      v-text="shortDescription"
    />
  </div>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
  concedente: {
    type: Object,
    default: () => ({}),
  },
});

const displayAddress = computed(() =>
  [!!props.concedente?.endereco, !!props.concedente?.tipo_concedente].some(
    Boolean
  )
);

const labelAddress = computed(() =>
  [
    props.concedente?.endereco?.cidade?.nome,
    props.concedente?.endereco?.cidade?.estado_sigla,
  ]
    .filter(Boolean)
    .join(" - ")
);

const shortDescription = computed(() =>
  [props.concedente?.tipo_concedente?.nome, labelAddress.value]
    .filter(Boolean)
    .join(" · ")
);

const isEncourager = computed(() => !!props.concedente?.lei_incentivo?.apoia);
</script>
